import get from 'lodash/get';
import pick from 'lodash/pick';

import { logger } from 'Services/logger/logger';
import { isDev } from 'Utilities/helpers';

import {
	ACCOUNT_ALLOWED_SLUGS,
	ACCOUNT_CATEGORIES,
	ACCOUNT_SLUGS,
} from '../components/pages/AccountPage/AccountPage.consts';
import { PurchasesCompleteStatusTypes } from '../types/purchaseCompleteStatus';
import { PUBLIC_ROUTES } from '../utilities/routes';

const qs = require('qs');

export const isAccountPageNotFound = (req) => {
	const { category, slug } = req.query || {};
	return !ACCOUNT_ALLOWED_SLUGS[category]?.includes(slug) ?? true;
};

export const ACCOUNT_BIDDING_HISTORY_ENDPOINTS = Object.freeze({
	[ACCOUNT_CATEGORIES.BIDS]: {
		[ACCOUNT_SLUGS.ACTIVE]: 'history-active',
		[ACCOUNT_SLUGS.UNDER_OFFER]: 'history-under-offer',
		[ACCOUNT_SLUGS.DIDNT_WIN]: 'history-did-not-win',
	},
	[ACCOUNT_CATEGORIES.PURCHASES]: {
		[ACCOUNT_SLUGS.COMPLETE]: 'history-purchases-complete',
		[ACCOUNT_SLUGS.CANCELLED]: 'history-purchases-cancelled',
	},
});

export const ACCOUNT_COMPLETE_STATUS_TYPES = Object.freeze({
	[PurchasesCompleteStatusTypes.All]: 'all-statuses',
	[PurchasesCompleteStatusTypes.AwaitingConfirmation]: 'awaiting-confirmation',
	[PurchasesCompleteStatusTypes.ChecksComplete]: 'checks-complete',
	[PurchasesCompleteStatusTypes.DeliveryRequested]: 'transport-requested',
	[PurchasesCompleteStatusTypes.ReviewingDocs]: 'reviewing-docs',
});

export const getAccountBiddingHistoryEndpointAndQueryParams = (query) => {
	const { category, purchasesCompleteStatusType, slug } = query;

	if (slug === ACCOUNT_SLUGS.COMPLETE) {
		if (query.from && query.to) {
			// We need to rename the query params to match the API
			const { from, to, ...filteredQuery } = query;

			query = {
				fromSoldDate: from,
				toSoldDate: to,
				...filteredQuery,
			};
		}

		query = {
			biddingHistoryStatus: ACCOUNT_COMPLETE_STATUS_TYPES[purchasesCompleteStatusType],
			...query,
		};
	}

	return { query, url: ACCOUNT_BIDDING_HISTORY_ENDPOINTS[category][slug] };
};

export const tokenize = (data) => Buffer.from(JSON.stringify(data)).toString('base64');

export const getTokenExpiredRedirect = (action, email) => {
	const pms = { action, email };
	const queryParams = { token: tokenize(pms) };
	return `${PUBLIC_ROUTES.TOKEN_EXPIRED}${qs.stringify(queryParams, { addQueryPrefix: true })}`;
};

export const safeApi =
	(api, scope, paramsToLog = '') =>
	async (req, res) => {
		try {
			await api(req, res);
		} catch (e) {
			const err = e || { message: 'Unknown error' };
			const severity = !err.silent || err.statusCode >= 500 ? 'error' : 'warn';
			const input = { ...req.query, ...req.body, ...req.params };
			const chosenParams = paramsToLog === '*' ? input : pick(input, paramsToLog);
			const requestData = paramsToLog ? chosenParams : {};
			const context = {
				paramsToLog,
				requestData,
				...(err.stack && { stack: err.stack }),
			};

			if (isDev) {
				console.error(err); // eslint-disable-line no-console -- it's useful for debugging
			}

			if (['critical', 'error'].includes(severity)) {
				// Attach err to be picked up by ddTracer
				res.err = err;
			}

			logger[severity]({ context, message: err.message, scope });

			res
				.status(get(err, 'response.status') || err.statusCode || 500)
				.send(get(err, 'response.data') || err.message || err.toString());
		}
	};
